<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <vs-tab
      icon-pack="feather"
      icon="icon-user"
      :label="!isSmallerScreen ? 'Dados Gerais' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-general :data="item" @done="saveData" />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-lock"
      :label="!isSmallerScreen ? 'Alterar Senha' : ''"
    >
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password :data="item" />
      </div>
    </vs-tab>

    <!-- <vs-tab
      disabled
      icon-pack="feather"
      icon="icon-bell"
      :label="!isSmallerScreen ? 'Notificações' : ''"
    >
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-notifications :data="item" />
      </div>
    </vs-tab> -->
  </vs-tabs>
</template>

<script>
import UserSettingsGeneral from "./components/UserSettingsGeneral.vue";
import UserSettingsChangePassword from "./components/UserSettingsChangePassword.vue";
import UserSettingsNotifications from "./components/UserSettingsNotifications.vue";

export default {
  data() {
    return {
      item: {},
      url: this.$route.meta.url,
    };
  },
  methods: {
    async getData(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.item = await this.$http.get(
          `${this.url}/${localStorage.getItem("uid")}`
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async saveData() {
      await this.$vs.loading();
      try {
        await this.$http.put(`${this.url}/${this.item.id}`, this.item);
        this.$vs.notify(this.$notify.Success);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
  },
  async mounted() {
    await this.getData();
  },
  components: {
    UserSettingsGeneral,
    UserSettingsChangePassword,
    UserSettingsNotifications,
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
